import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import { Icon, Grid, IconButton, Dialog, Button, DialogContent, DialogActions, Typography} from '@mui/material';

import {
  toggleModalForm
} from '../../../actions';

import ObiActionTitle from '../ObiActionTitle';
import CloseIcon from '@mui/icons-material/Close';
import { IntroChangesMyOEE, IntroChangesMyOBC, IntroChangesMyOAgent } from '../../../utility/common/GlobalHSA.js';

const styles = theme => ({
  grey:{
    color: theme.palette.grey.main
  },
  bggrey:{
    backgroundColor: theme.palette.grey.dark,
    padding: '10px',
  },
})

class TourMyOlympia extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      tourIndex: 0
    };
  }

  handleClose = () => {
    this.props.toggleModalForm(false);
  };

  prevTourElement = (event) => {
    var value = parseInt(this.state.tourIndex) - 1;

    if(value < 0) {
      value = 0;
    }
     
    this.setState({
      tourIndex: value,
    });
  }

  nextTourElement = (event, lastElement) => {
    var value = parseInt(this.state.tourIndex) + 1;

    if(lastElement) {
      value = 0;
    }
    this.setState({
      tourIndex: value,
    });
  }

  endTourElement = (event, lastElement) => {
    this.handleClose();
  }

  render() {
    const { classes } = this.props;

    if (this.props.modalForm.contentComponent !== "introTour"){
      return false;
    }
 
    let modalTitle = 'Title';
    let modalText = 'Text';
    //let modalImage = '';
    let lastElement = false;
    let modalElements = [];

    if(this.props.modalForm.data === 'EE' ){
      modalElements = IntroChangesMyOEE;
      lastElement = IntroChangesMyOEE.length <= this.state.tourIndex + 1;
      modalTitle = IntroChangesMyOEE[this.state.tourIndex].title;
      modalText = IntroChangesMyOEE[this.state.tourIndex].text;
      //modalImage = IntroChangesMyOEE[this.state.tourIndex].img;
    }
    else if (this.props.modalForm.data === 'BC'){
      modalElements = IntroChangesMyOBC;
      lastElement = IntroChangesMyOBC.length <= this.state.tourIndex + 1;
      modalTitle = IntroChangesMyOBC[this.state.tourIndex].title;
      modalText = IntroChangesMyOBC[this.state.tourIndex].text;
      //modalImage = IntroChangesMyOBC[this.state.tourIndex].img;
    }
    else if (this.props.modalForm.data === 'AGENT'){
      modalElements = IntroChangesMyOAgent;
      lastElement = IntroChangesMyOAgent.length <= this.state.tourIndex + 1;
      modalTitle = IntroChangesMyOAgent[this.state.tourIndex].title;
      modalText = IntroChangesMyOAgent[this.state.tourIndex].text;
      //modalImage = IntroChangesMyOAgent[this.state.tourIndex].img;
    }

    return (
      <Dialog
        open={this.props.modalForm.open}
        onClose={this.endTourElement}
        aria-labelledby="form-dialog-title"
        maxWidth={'sm'}
      >
        <ObiActionTitle type='dialog' title={''}>
          <IconButton size="small" onClick={this.endTourElement}>
            <Icon className={classes.grey} component={CloseIcon}></Icon>
          </IconButton>
        </ObiActionTitle>
        <DialogContent>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2} className={classes.bggrey}>
                {modalElements.map((modalElement, index)=>{
                  return (
                    //<Hidden xsUp={index !== this.state.tourIndex}>
                      <Grid key={'tour'+index}>
                        <img src={modalElement.img} alt={modalElement.title} style={{maxWidth: '100%', maxHeight:'250px', userSelect: 'none', display:(index !== this.state.tourIndex)? 'none': 'block'}}></img>
                      </Grid>
                    //</Hidden>
                    );
                })}
              </Grid>
            </Grid>  
            <Grid item>
              <Typography align="center" variant="h6">
                {modalTitle}
              </Typography>
              <Typography align="center" variant="body2">
                {modalText}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {(this.state.tourIndex > 0) && 
          <Button type="submit" onClick={(event) => this.prevTourElement(event)} color={"primary"}>
            Previous
          </Button>}

          {!lastElement && 
          <Button type="submit" variant="contained" onClick={(event) => this.nextTourElement(event, lastElement)} color={"primary"}>
            Next
          </Button>}

          {lastElement &&
          <Button type="submit" variant="contained" onClick={this.endTourElement} color={"secondary"}>
            Exit
          </Button>}

        </DialogActions>
      </Dialog>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.general.loading,
    modalForm: state.general.modalForm,
  };
};

export default withStyles(styles, { withTheme: true }) (connect(mapStateToProps, {
  toggleModalForm,
})(TourMyOlympia));
